import { dataTestId } from 'modules/experiments/constants';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import {
  useTakeoverExperimentContext,
  useVariantConfigurationContext,
} from 'modules/experiments/contexts';
import { Add16, Save } from 'ui/icons';
import { Tooltip } from 'ui/tooltip';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import { VariantCardFooterWrapper } from './Styled';

export const NonEditableCardAction = () => {
  const { t } = useExperimentsTranslations();
  const { isRunningExperiment } = useTakeoverExperimentContext();
  const { hasMaximumNumberOfVariants, addNewVariant, toggleToPreviewSelectMode } =
    useVariantConfigurationContext();

  return (
    <VariantCardFooterWrapper data-test={dataTestId.variantCardFooterNonEditable}>
      {!isRunningExperiment && (
        <Tooltip
          isEnabled={hasMaximumNumberOfVariants}
          tooltipContent={t('variantCard.tooltip.disableVariantCreation')}
        >
          <SecondaryButton isDisabled={hasMaximumNumberOfVariants} onClick={addNewVariant}>
            <Add16 /> {t('button.saveAndAddVariant')}
          </SecondaryButton>
        </Tooltip>
      )}
      <PrimaryButton onClick={toggleToPreviewSelectMode}>
        <Save height={16} width={16} /> {t('button.save')}
      </PrimaryButton>
    </VariantCardFooterWrapper>
  );
};
